module.exports = __webpack_public_path__ + "static/media/team-member-04.3ae06192.jpg";